import React from 'react';
import { Helmet } from 'react-helmet-async';

const OG_IMAGE_URL = "https://static.prod-images.emergentagent.com/jobs/3f8ee34a-b405-49e5-a6e6-3ec98fdd1fc1/images/f56b0cd6adaf2b8ea0b07edcb439a6201de0dfef385e07ede3bb900b2d351f18.png";
const SITE_URL = "https://mddreminder.uk";

export default function SEO({ 
  title = "My Direct Debits – Direct Debit Reminder App | Track Your Payments",
  description = "Your bank doesn't warn you. We do. Track all your recurring payments, get smart reminders before money leaves your account. Free to start.",
  path = ""
}) {
  const fullUrl = `${SITE_URL}${path}`;
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={OG_IMAGE_URL} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:url" content={fullUrl} />
    </Helmet>
  );
}
